import { type ProcedimentoConTask } from '@framework/api-client/api/backoffice/schemas/procedimentoConTask.ts';
import { procedureToDescriptionsItems } from '@framework/common-web/ui/description/procedureToDescriptionsItems.tsx';
import { DescriptionsGroup } from '@framework/ui/components/description/DescriptionsGroup.tsx';

export interface IDossierDescriptionsTabProps {
  dossierProcedure: ProcedimentoConTask;
}

/**
 * Pagina che raccoglie i dati della pratica
 */
export function DossierDescriptionsTab(props: IDossierDescriptionsTabProps) {
  const { dossierProcedure } = props;

  const items = procedureToDescriptionsItems(dossierProcedure)
    .filter(ele => !ele.excludeFrontoffice)
    .map(item => ({
      label: item.label,
      children: item.children,
      span: item.span,
    }));

  return <DescriptionsGroup items={items} />;
}
